<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <g fill="none" fill-rule="evenodd">
        <g>
            <g>
                <g>
                    <path d="M5 5L24.541 5 24.541 24.568 5 24.568z" transform="translate(-1202 -209) translate(782 193) translate(420 16)"/>
                    <path fill="#FFF" d="M17.043 14.784l7.027-7.04c.629-.628.627-1.647-.001-2.275-.63-.627-1.646-.625-2.275.002l-7.024 7.037L7.747 5.47c-.627-.627-1.645-.63-2.276-.002-.627.628-.628 1.647 0 2.275l7.026 7.04-7.027 7.04c-.627.627-.626 1.647.001 2.274.315.314.726.47 1.138.47.413 0 .823-.158 1.138-.472l7.023-7.035 7.024 7.035c.314.314.725.472 1.137.472.412 0 .824-.156 1.138-.47.628-.627.63-1.647.001-2.275l-7.027-7.039z" transform="translate(-1202 -209) translate(782 193) translate(420 16)"/>
                </g>
            </g>
        </g>
    </g>
</svg>
